import { useCallback, useEffect, useState } from "react";
import { Row } from "antd";
import { useHistory } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

import { FichaService } from "../../services/ficha.service";

import { TableValidacao } from "../../components/table/validacao";
import { Wrapper } from "./styles";

import { Search } from "../../components/search";

export function Dip() {
  const history = useHistory();
  const [lista, setLista] = useState({
    data: [],
    totalElements: 0,
  });

  const [state, setState] = useState({
    page: 1,
    size: 5,
    nome: null,
    cpf: null,
    sistema: null,
  });

  const [loading, setLoading] = useState(false);

  const load = useCallback( async({state}) => {
    setLoading(true)
    try{
      const { page, size, nome, cpf, sistema } = state;
      const patt1 = /[0-9]/g;
      await FichaService.getListInteligenciaDip({
        page,
        size,
        nome,
        cpf: cpf ? cpf.match(patt1).join("") : null,
        sistema,
      }).then(({ data }) => {
        setLista({
          data: data.content,
          totalElements: data.totalElements,
        });
      });
    }catch(err){
      console.log(err);
    }finally{
      setLoading(false)
    }
  } ,[]);

  const update = useCallback(
    (newValues) => setState((prev) => ({ ...prev, ...newValues })),
    []
  );

  useEffect(() => {
   load({state});
  }, [load, state, update]);

  return (
    <Wrapper>
      <Row>
        <ArrowLeftOutlined
          className="btnBack"
          onClick={() => history.goBack()}
          style={{ fontSize: "16px", marginRight: 10, marginTop: 10 }}
        />
        <h1>Fichas para aprovação DIP</h1>
      </Row>

      <Search
        onClear={() =>
          update({
            nome: null,
            cpf: null,
            sistema: null,
          })
        }
        onSearch={(v) => update({ ...v, page: 1 })}
      />
      <div className="scollTable">
        <TableValidacao
          loading={loading}
          data={lista.data}
          totalElements={lista.totalElements}
          page={state.page}
          size={state.size}
          module="dip"
          onChangeSize={(size) => update({size})}
          onChangePage={(page) => update({ page })}
        />
      </div>
    </Wrapper>
  );
}
